import { isDirectUploadPlatform } from "~/modules/shared/utils/sourceFilterOptions";

/**
 * Whether `url` is a normal web link the browser can open (e.g. a YouTube post).
 * Upload and storage schemes are internal and must not be offered as "Platform" links.
 */
export function isExternalBrowsablePostUrl(
	url: string | null | undefined,
): boolean {
	const trimmed = url?.trim();
	if (!trimmed) {
		return false;
	}
	if (trimmed.startsWith("upload://") || trimmed.startsWith("s3://")) {
		return false;
	}
	try {
		const parsed = new URL(trimmed);
		return parsed.protocol === "http:" || parsed.protocol === "https:";
	} catch {
		return false;
	}
}

/** Post or profile URL to open for "Platform", or undefined when there is none. */
export function externalPlatformPostUrl(
	postUrl: string | null | undefined,
	profileUrl: string | null | undefined,
): string | undefined {
	const post = postUrl?.trim();
	if (isExternalBrowsablePostUrl(post)) {
		return post;
	}
	const profile = profileUrl?.trim();
	if (isExternalBrowsablePostUrl(profile)) {
		return profile;
	}
	return undefined;
}

/** Off-site profile URL for a social row, if the platform has one. */
export function externalSocialProfileUrl(
	platform: string | null | undefined,
	profileUrl: string | null | undefined,
): string | undefined {
	if (isDirectUploadPlatform(platform)) {
		return undefined;
	}
	return isExternalBrowsablePostUrl(profileUrl) ? profileUrl?.trim() : undefined;
}

/** URL for the video panel "Platform" action, if the clip has a real off-site post. */
export function platformLinkForVideoEvidence(
	clip:
		| {
				post_url?: string | null;
				social_account?: { platform?: string | null; profile_url?: string | null };
		  }
		| undefined,
): string | undefined {
	if (!clip || isDirectUploadPlatform(clip.social_account?.platform)) {
		return undefined;
	}
	return externalPlatformPostUrl(
		clip.post_url,
		clip.social_account?.profile_url,
	);
}
